export default "__VITE_ASSET__B1AFP9S$__"